export default "__VITE_PUBLIC_ASSET__b36a369a__"